import { render, staticRenderFns } from "./ClassRequestsPanel.vue?vue&type=template&id=66bf8e44&scoped=true"
import script from "./ClassRequestsPanel.vue?vue&type=script&lang=js"
export * from "./ClassRequestsPanel.vue?vue&type=script&lang=js"
import style0 from "./ClassRequestsPanel.vue?vue&type=style&index=0&id=66bf8e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf8e44",
  null
  
)

export default component.exports